import proj4 from "proj4";

// EPSG:25830 — ETRS89 / UTM zone 30N (Spanish legal geodetic standard)
proj4.defs(
  "EPSG:25830",
  "+proj=utm +zone=30 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"
);

// Convert WGS84 lat/lng -> EPSG:25830 easting/northing (metres)
export function toEPSG25830(lat, lng) {
  const [x, y] = proj4("EPSG:4326", "EPSG:25830", [lng, lat]);
  return { x, y };
}

export const LEGAL_CRS = "EPSG:25830";
